<template>
    <div class="page-login">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="token" prop="token">
                <el-input v-model="ruleForm.token"></el-input>
            </el-form-item>
            <el-form-item label="url" prop="url">
                <el-input v-model="ruleForm.url"></el-input>
            </el-form-item>
            <el-form-item label="参数" prop="param">
                <el-input type="textarea" v-model="ruleForm.param" rows="20"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import { login,getUser } from '@/api/user.js';
    export default {
        data() {
            return {
                ruleForm: {
                    token: "",
                    url: "",
                    param: ""
                },
                rules: {
                    url: [{
                        required: true,
                        message: '请输入API地址',
                        trigger: 'blur'
                    }],
                    param: [{
                        required: true,
                        message: '请输入参数',
                        trigger: 'blur'
                    }]
                }
            }
        },
        methods: {
            submitForm(formName) {

                if(this.ruleForm.token) {
                    window.localStorage.setItem("userToken", this.ruleForm.token);
                    this.$store.commit('SET_TOKEN', this.ruleForm.token);
                }

                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let jsonstr = this.ruleForm.param.replace(/[\r\n]/g,"");
                        console.log(jsonstr)
                        let params =  eval('(' + jsonstr + ')');//JSON.parse(p);
                        console.log(params)
                        request.post(this.ruleForm.url,params).then((response)=>{
                            console.log(response.data);                            
                        })
                        
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style lang="scss">
    .page-login {
        width: 600px;
        margin: 100px auto 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/demo/api.vue